import { GET_HADEETH } from "../graphql/queries/hadeeth";
import { useQuery } from "@apollo/client";

export const useHadeeth = () => {
  const { loading, error, data } = useQuery(GET_HADEETH);
  return {
    loading,
    data,
    error,
  };
};
